import React, { useEffect, useState } from "react";
import { Button, Box, Card, CardContent, Grid, Typography, TextField, Select, MenuItem, FormHelperText, FormControl } from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { useDeadline } from "../../../../contexts/DeadlineContext";

const AddEmailTempletes = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const { offButton, abstractHomeSetup } = useDeadline();
    const [disabled, setDisabled] = useState(true);
    const [addEmailTemp, setAddEmailTemp] = useState({
        email_title: "",
        email_subject: "",
        email_variables: "",
        error_list: [],
    });

    const handleInput = (e) => {
        e.persist();
        setAddEmailTemp({ ...addEmailTemp, [e.target.name]: e.target.value });
        validateForm(); // Validate form after every input change
    };

    const insertVariable = (variable) => {
        const input = document.getElementById('emailVariablesInput');

        const cursorPosition = input.selectionStart;

        const currentValue = addEmailTemp.email_variables;

        const newValue = currentValue.slice(0, cursorPosition) + variable + currentValue.slice(cursorPosition);

        setAddEmailTemp({
            ...addEmailTemp,
            email_variables: newValue
        });

        setTimeout(() => {
            input.selectionStart = input.selectionEnd = cursorPosition + variable.length;
        }, 0);
    };

    const validateForm = () => {
        const { email_title, email_subject, email_variables } = addEmailTemp;
        if (email_title && email_subject && email_variables) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    };
    const [emailTemplateTitle, setEmailTemplateTitle] = useState(false);
    useEffect(() => {
        axios.get(`/api/get-abstract-template-title?id=${eventid}`).then(res => {
            if (res.status === 200 && Array.isArray(res.data.gett)) {
                setEmailTemplateTitle(res.data.gett);
            }

        });

    }, []);
    const handleSelectChange = (event) => {
        const selectedValue = event.target.value; // Get the selected value (id)
        setAddEmailTemp((prev) => ({
            ...prev,
            email_title: selectedValue,
        }));
    };

    const absCateSubmit = (e) => {
        e.preventDefault();
        const data = {
            eventid,
            email_title: addEmailTemp.email_title,
            email_subject: addEmailTemp.email_subject,
            email_variables: addEmailTemp.email_variables,
        };

        axios.get('/sanctum/csrf-cookie').then(() => {
            axios.post(`/api/store-abstract-registration-email-template`, data).then(res => {
                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');

                    history.push('/admin/abstract/index-template');
                } else {
                    setAddEmailTemp({ ...addEmailTemp, error_list: res.data.validate_error });
                }
            });
        });
    };

    let backGroundButtonByEvent = eventid ? `${abstractHomeSetup.color_code_two}` : '#145348';

    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000' }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }}>
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        backgroundColor: backGroundButtonByEvent,
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={() => { history.goBack() }}>
                        Back
                    </Button>
                    <Button sx={{
                        float: 'right',
                        marginRight: '1%',
                        backgroundColor: backGroundButtonByEvent,
                        marginTop: '2%',
                        ":hover": {
                            color: "white"
                        },

                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        component={Link}
                        to="/admin/abstract/title-template">
                        Add Email Title
                    </Button>

                </h4>
                <Card sx={{ width: '60vw', float: 'center' }}>
                    <CardContent>
                        <Typography component="h1" variant="h5">
                            Add Email Template
                        </Typography>
                        <Box component="form" onSubmit={absCateSubmit} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>
                                {/* <Grid item xs={6}>
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Email Title"
                                        name='email_title'
                                        onChange={handleInput}
                                        value={addEmailTemp.email_title}
                                        helperText={addEmailTemp.error_list.email_title}
                                    />
                                </Grid> */}
                                <Grid item xs={6}>
                                    <FormControl fullWidth required error={!!addEmailTemp.error_list.email_title}>
                                        <Select
                                            name="email_title"
                                            value={addEmailTemp.email_title || ''}
                                            onChange={handleSelectChange}
                                            displayEmpty
                                        >
                                            <MenuItem value="" disabled>
                                                Select an Email Title
                                            </MenuItem>
                                            {emailTemplateTitle && emailTemplateTitle?.map((template) => (
                                                <MenuItem key={template.id} value={template.id}>
                                                    {template.title}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText>{addEmailTemp.error_list.email_title}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Email Subject"
                                        name='email_subject'
                                        onChange={handleInput}
                                        value={addEmailTemp.email_subject}
                                        helperText={addEmailTemp.error_list.email_subject}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        id="emailVariablesInput"
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Email Variables"
                                        name="email_variables"
                                        onChange={handleInput}
                                        value={addEmailTemp.email_variables}
                                        multiline
                                        rows={6}
                                        helperText={addEmailTemp.error_list.email_variables}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Button
                                        variant="outlined"
                                        onClick={() => insertVariable('{name}')}
                                        sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
                                    >
                                        Insert Name
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => insertVariable('{email}')}
                                        sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
                                    >
                                        Insert Email
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => insertVariable('{password}')}
                                        sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
                                    >
                                        Insert Password
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => insertVariable('{abstract_title}')}
                                        sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
                                    >
                                        Abstract Title
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => insertVariable('{conference_name}')}
                                        sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
                                    >
                                        Conference Name
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => insertVariable('{issues}')}
                                        sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
                                    >
                                        Issue
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => insertVariable('{submision_type}')}
                                        sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
                                    >
                                        Submision Type
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => insertVariable('{submision_type}')}
                                        sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
                                    >
                                        Submision Type
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => insertVariable('{date}')}
                                        sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
                                    >
                                        Date
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => insertVariable('{time}')}
                                        sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
                                    >
                                        Time
                                    </Button>
                                  
                                    <Button
                                        variant="outlined"
                                        onClick={() => insertVariable('{header_image}')}
                                        sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
                                    >
                                        Header Banner
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => insertVariable('{footer_image}')}
                                        sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
                                    >
                                        Footer
                                    </Button>
                                    {/* <Button variant="outlined" onClick={() => insertVariable('{qrcode}')}>Insert QR Code</Button> */}
                                </Grid>

                            </Grid>

                            <Grid container justifyContent="flex-end">
                                <Button
                                    //disabled={disabled}
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 5, backgroundColor: backGroundButtonByEvent }}
                                >
                                    Add Template
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
};

export default AddEmailTempletes;
